// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ct-page-bg {
  background-color: var(--lPink);
  padding: 0px 5%;
}

.course-title-tvp h1 {
  color: var(--dBlue);
}

.rating-btn {
  display: flex;
  text-align: center;
}

.leave-rating button,
.course-progress {
  background-color: var(--white) !important;
  color: var(--blue);
  text-transform: uppercase;
  border-radius: 30px;
  font-family: "Poppins";
  border: 1px solid var(--cSPink);
  font-size: 16px;
  font-weight: 700;
  padding: 6px 15px 5px 3px;
}

.leave-rating button:hover {
  color: var(--blue);
}

.rating-progress-btns {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 2% 0;
}

.btn-icon-star {
  border: 1px solid #d9d9d9;
  border-radius: 50%;
  padding: 5px 3px;
  margin-right: 10px;
}

.btn-icon-star svg,
.inner svg {
  color: #f1c300 !important;
  font-size: 25px;
}

.course-progress {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 0px;
}

.progress-txt {
  padding: 0 15px;
}

.progress-txt p {
  margin: 0px;
}

/* Image wrap circle progress bar  */
.circle {
  position: relative;
  width: 35px;
  height: 35px;
  margin: 5%;
  border-radius: 50%;
  background: #ffcdb2;
  overflow: hidden;
}

.circle.progress-per {
  background-image: conic-gradient(var(--dBlue) 25%, #d9d9d9 0);
}

.circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  background: var(--white);
  border-radius: 50%;
  padding: 5px;
}

.video-course-content {
  padding-left: 20px;
  padding-right: 20px;
}

/* Lecture Content - Accordion  */
.course-content-list {
  --bs-accordion-border-color: var(--blue);
  --bs-accordion-border-width: 2px;
  --bs-accordion-border-radius: 15px;
  --bs-accordion-inner-border-radius: calc(16px - 1px);
}

.unit-name {
  --bs-accordion-active-color: var(--dPink);
}

.unit-name button {
  background-color: var(--uPCBlue);
  color: var(--dPink);
  font-weight: 700;
  text-transform: uppercase;
  padding: 20px;
}

.unit-name .accordion-button::after {
  color: var(--dBlue);
}

/* Course Content  */
.lesson {
  display: flex;
  align-items: center;
  column-gap: 5%;
  /* padding: 20px; */
  cursor: pointer;
  /* border-bottom: 1px solid #cccccc94; */
  justify-content: space-between;
  margin-bottom: 10px;
}

.video-icon svg {
  color: var(--dBlue);
  font-size: 30px;
}

/* Tab  */

#player-container {
    width: 100%;
    /* Adjust this value as needed */
    /* max-width: 800px; Set a maximum width if desired */
    /* height: 50vh; */
    height: 534px;
    /* padding-bottom: 56.25%; 16:9 aspect ratio (change if your videos have a different aspect ratio) */
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    /* background: #000; */
}

.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
}

.modal.open {
  display: flex;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  width: 40%;
}

.star-rating {
  display: flex;
  margin-bottom: 10px;
}

.star-rating span {
  font-size: 24px;
}

.review-section textarea {
  width: 100%;
  resize: vertical;
}

.submit-button-wrapper {
  text-align: right;
}

.submit-button-wrapper .btn {
  background: #264ec8;
  border-radius: 40px;
  color: #fff;
  padding: 8px 20px;
  border-radius: 40px;
  font-size: 12px;
}

.close-rating-btn {
  cursor: pointer;
}

/* .tutorial-pg-tab li:first-child {
  display: none;
} */

.course-title-tvp {
  padding-top: 1%;
}

.player-loader-wrapper{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000ad;
  position: absolute;
  z-index: 99;
  top: 0;
  left: 0;
}

@media (max-width: 767px) {
  .course-title-tvp {
    text-align: center;
  }

  .course-title-tvp h1 {
    font-size: 22px;
  }

  .tutorial-pg-tab {
    align-items: center;
    overflow-x: auto;
    column-gap: 5px;
    padding-bottom: 0px;
  }

  .tutorial-pg-tab li {
    padding: 10px;
  }

  .p-0-mob {
    padding: 0px;
  }

  .video-course-content {
    padding: 15px 5px;
  }

  .tutorial-pg-tab li:first-child {
    display: block;
    white-space: nowrap;
  }

  .tutorial-page-tab > div {
    padding-top: 30px;
  }

  #player-container {
    height: 220px;
    margin-top: 15px;
  }
}

.quiz-btn,
.quiz-btn:hover {
  background: #264ec8;
  border-radius: 40px;
  color: #fff;
  width: 100%;
}

.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.snap-scratch-wrapper {
  display: flex;
  column-gap: 10px;
}

.single-button {
    display: flex;
    justify-content: center;
}

.multiple-buttons {
    display: flex;
    justify-content: start;
}

/* Adjust button width for single button case */
.single-button .btn {
    width: 100%;
}

/* {
    width: 100%;
    border-radius: 13px;
    padding: 15px 0;
    font-weight: 700;
    text-transform: uppercase;
} */

/* .snap-scratch-wrapper .btn {
    text-transform: capitalize;
} */

.star-rating svg {
    color: var(--dPink);
}

#player-container iframe {
    width: 100%;
    min-height: 540px;
    /* height: 100%; */
}

.success-review-text {
    font-size: 20px;
}

.ceritficate-modal-content {
    background-color: #00000070;
    padding: 20px;
    border-radius: 4px;
    width: 100%;
}

.close-ceritificate-btn {
    position: absolute;
    top: 6%;
    right: 30px;
    color: #ff0000;
    font-size: 35px;
    background: #fff;
    border-radius: 50%;
    cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/component/course-page/TutorialVideos.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,wCAAwC;EACxC,gCAAgC;EAChC,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,SAAS;;AAET;IACI,WAAW;IACX,gCAAgC;IAChC,qDAAqD;IACrD,kBAAkB;IAClB,aAAa;IACb,oGAAoG;IACpG,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;AACT;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA,+CAA+C;AAC/C;IACI,WAAW;AACf;;AAEA;;;;;;GAMG;;AAEH;;GAEG;;AAEH;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".ct-page-bg {\r\n  background-color: var(--lPink);\r\n  padding: 0px 5%;\r\n}\r\n\r\n.course-title-tvp h1 {\r\n  color: var(--dBlue);\r\n}\r\n\r\n.rating-btn {\r\n  display: flex;\r\n  text-align: center;\r\n}\r\n\r\n.leave-rating button,\r\n.course-progress {\r\n  background-color: var(--white) !important;\r\n  color: var(--blue);\r\n  text-transform: uppercase;\r\n  border-radius: 30px;\r\n  font-family: \"Poppins\";\r\n  border: 1px solid var(--cSPink);\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  padding: 6px 15px 5px 3px;\r\n}\r\n\r\n.leave-rating button:hover {\r\n  color: var(--blue);\r\n}\r\n\r\n.rating-progress-btns {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-evenly;\r\n  padding: 2% 0;\r\n}\r\n\r\n.btn-icon-star {\r\n  border: 1px solid #d9d9d9;\r\n  border-radius: 50%;\r\n  padding: 5px 3px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.btn-icon-star svg,\r\n.inner svg {\r\n  color: #f1c300 !important;\r\n  font-size: 25px;\r\n}\r\n\r\n.course-progress {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-evenly;\r\n  padding: 0px;\r\n}\r\n\r\n.progress-txt {\r\n  padding: 0 15px;\r\n}\r\n\r\n.progress-txt p {\r\n  margin: 0px;\r\n}\r\n\r\n/* Image wrap circle progress bar  */\r\n.circle {\r\n  position: relative;\r\n  width: 35px;\r\n  height: 35px;\r\n  margin: 5%;\r\n  border-radius: 50%;\r\n  background: #ffcdb2;\r\n  overflow: hidden;\r\n}\r\n\r\n.circle.progress-per {\r\n  background-image: conic-gradient(var(--dBlue) 25%, #d9d9d9 0);\r\n}\r\n\r\n.circle .inner {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 30px;\r\n  height: 30px;\r\n  background: var(--white);\r\n  border-radius: 50%;\r\n  padding: 5px;\r\n}\r\n\r\n.video-course-content {\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n/* Lecture Content - Accordion  */\r\n.course-content-list {\r\n  --bs-accordion-border-color: var(--blue);\r\n  --bs-accordion-border-width: 2px;\r\n  --bs-accordion-border-radius: 15px;\r\n  --bs-accordion-inner-border-radius: calc(16px - 1px);\r\n}\r\n\r\n.unit-name {\r\n  --bs-accordion-active-color: var(--dPink);\r\n}\r\n\r\n.unit-name button {\r\n  background-color: var(--uPCBlue);\r\n  color: var(--dPink);\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  padding: 20px;\r\n}\r\n\r\n.unit-name .accordion-button::after {\r\n  color: var(--dBlue);\r\n}\r\n\r\n/* Course Content  */\r\n.lesson {\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 5%;\r\n  /* padding: 20px; */\r\n  cursor: pointer;\r\n  /* border-bottom: 1px solid #cccccc94; */\r\n  justify-content: space-between;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.video-icon svg {\r\n  color: var(--dBlue);\r\n  font-size: 30px;\r\n}\r\n\r\n/* Tab  */\r\n\r\n#player-container {\r\n    width: 100%;\r\n    /* Adjust this value as needed */\r\n    /* max-width: 800px; Set a maximum width if desired */\r\n    /* height: 50vh; */\r\n    height: 534px;\r\n    /* padding-bottom: 56.25%; 16:9 aspect ratio (change if your videos have a different aspect ratio) */\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n    /* background: #000; */\r\n}\r\n\r\n.modal {\r\n  display: none;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.modal.open {\r\n  display: flex;\r\n}\r\n\r\n.modal-content {\r\n  background-color: #fff;\r\n  padding: 20px;\r\n  border-radius: 4px;\r\n  width: 40%;\r\n}\r\n\r\n.star-rating {\r\n  display: flex;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.star-rating span {\r\n  font-size: 24px;\r\n}\r\n\r\n.review-section textarea {\r\n  width: 100%;\r\n  resize: vertical;\r\n}\r\n\r\n.submit-button-wrapper {\r\n  text-align: right;\r\n}\r\n\r\n.submit-button-wrapper .btn {\r\n  background: #264ec8;\r\n  border-radius: 40px;\r\n  color: #fff;\r\n  padding: 8px 20px;\r\n  border-radius: 40px;\r\n  font-size: 12px;\r\n}\r\n\r\n.close-rating-btn {\r\n  cursor: pointer;\r\n}\r\n\r\n/* .tutorial-pg-tab li:first-child {\r\n  display: none;\r\n} */\r\n\r\n.course-title-tvp {\r\n  padding-top: 1%;\r\n}\r\n\r\n.player-loader-wrapper{\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #000000ad;\r\n  position: absolute;\r\n  z-index: 99;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .course-title-tvp {\r\n    text-align: center;\r\n  }\r\n\r\n  .course-title-tvp h1 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .tutorial-pg-tab {\r\n    align-items: center;\r\n    overflow-x: auto;\r\n    column-gap: 5px;\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .tutorial-pg-tab li {\r\n    padding: 10px;\r\n  }\r\n\r\n  .p-0-mob {\r\n    padding: 0px;\r\n  }\r\n\r\n  .video-course-content {\r\n    padding: 15px 5px;\r\n  }\r\n\r\n  .tutorial-pg-tab li:first-child {\r\n    display: block;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .tutorial-page-tab > div {\r\n    padding-top: 30px;\r\n  }\r\n\r\n  #player-container {\r\n    height: 220px;\r\n    margin-top: 15px;\r\n  }\r\n}\r\n\r\n.quiz-btn,\r\n.quiz-btn:hover {\r\n  background: #264ec8;\r\n  border-radius: 40px;\r\n  color: #fff;\r\n  width: 100%;\r\n}\r\n\r\n.button-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.snap-scratch-wrapper {\r\n  display: flex;\r\n  column-gap: 10px;\r\n}\r\n\r\n.single-button {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.multiple-buttons {\r\n    display: flex;\r\n    justify-content: start;\r\n}\r\n\r\n/* Adjust button width for single button case */\r\n.single-button .btn {\r\n    width: 100%;\r\n}\r\n\r\n/* {\r\n    width: 100%;\r\n    border-radius: 13px;\r\n    padding: 15px 0;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n} */\r\n\r\n/* .snap-scratch-wrapper .btn {\r\n    text-transform: capitalize;\r\n} */\r\n\r\n.star-rating svg {\r\n    color: var(--dPink);\r\n}\r\n\r\n#player-container iframe {\r\n    width: 100%;\r\n    min-height: 540px;\r\n    /* height: 100%; */\r\n}\r\n\r\n.success-review-text {\r\n    font-size: 20px;\r\n}\r\n\r\n.ceritficate-modal-content {\r\n    background-color: #00000070;\r\n    padding: 20px;\r\n    border-radius: 4px;\r\n    width: 100%;\r\n}\r\n\r\n.close-ceritificate-btn {\r\n    position: absolute;\r\n    top: 6%;\r\n    right: 30px;\r\n    color: #ff0000;\r\n    font-size: 35px;\r\n    background: #fff;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
